import './BuyConfirmation.css'


const BuyConfirmation = () => {
    
    return (
        <div className="BuyConfirmation pr-page">
            <h1>Vielen Dank für ihren Kauf!</h1>
            <p>Alle Informationen zu Ihren Artikeln finden Sie unter <a href="/Profil/Bestellungen">Bestellungen</a> in ihrem Profil.</p>
        </div>
    )
}
export default BuyConfirmation
